import axios from './index';

/**
 * Types
 */
import { Response } from '@/dtos/common.dto';
import { CreateUserDto, QueryUserDto, UpdateUserDto, UserDto } from '@/dtos/user.dto';

/**
 * APIs
 */
// 创建用户信息
export function cUser(data: CreateUserDto) {
    return axios<Response<UserDto>>('/v1/users', {
        data,
        method: 'post',
    });
}

// 获取用户列表
export function users(params?: QueryUserDto) {
    return axios<Response<UserDto[]>>('/v1/users', {
        method: 'get',
        params,
    });
}

// 获取用户信息
export function rUser(id: string) {
    return axios<Response<UserDto>>(`/v1/users/${id}`, {
        method: 'get',
    });
}

// 编辑用户信息
export function uUser({ id, ...data }: { id: string } & UpdateUserDto) {
    return axios<Response<UserDto>>(`/v1/users/${id}`, {
        data,
        method: 'patch',
    });
}

// 删除用户信息
export function dUser(id: string) {
    return axios<Response>(`/v1/users/${id}`, {
        method: 'delete',
    });
}
